import { Middleware } from '@reduxjs/toolkit';

import {
  confirmPaymentFailure,
  confirmPaymentSuccess,
  initiateConfirmation,
  setConfirmationFormStatus,
} from '@cashier/cashier-data-access';
import { FormStatuses } from '@cashier/cashier-model';

export const confirmationFormMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === initiateConfirmation.toString()) {
      store.dispatch(setConfirmationFormStatus(FormStatuses.SUBMITTED));
    }

    if (action.type === confirmPaymentSuccess.toString()) {
      store.dispatch(setConfirmationFormStatus(FormStatuses.SUCCEEDED));
    }

    if (action.type === confirmPaymentFailure.toString()) {
      store.dispatch(setConfirmationFormStatus(FormStatuses.FAILED));
    }

    return result;
  };
